module.exports = __webpack_public_path__ + "2fe4d35c5ec005999fee9f9746c58cf7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-lines-brown.png
// module id = 1376
// module chunks = 0